import * as actionTypes from '../actions/ActionTypes'

export default function(state = [], action) {
  switch (action.type) {
    case actionTypes.LISTS_CUSTOMER_UPDATE:
      return action.listsCustomer
    default:
      return state
  }
}